import { Paper } from '@trackman/web-shared-components';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { TaggingStore } from 'stores/Tagging/TaggingStore';
import { IInning } from 'interfaces/tagging/IInning';
import { useInjection } from 'services/ioc/ioc.react';
import { ServiceTypes } from 'constants/ServiceTypes';
import { SessionStore } from 'stores/SessionStore';
import { SessionMode } from 'enums/SessionMode';
import PlayPlaceholder from 'components/playPlaceholder/PlayPlaceholder';
import { AddPlayMenu } from './AddPlayMenu/AddPlayMenu';
import { SectionHeadline } from '../SectionHeadline/SectionHeadline';
import { InningSection } from './InningSection/InningSection';
import { PlayListWrapper } from './PlayListStyles';

const PlayList: React.FC = observer(() => {
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);
  const { playStore } = useInjection<TaggingStore>(ServiceTypes.TaggingStore);

  const renderPlaceholder = (): boolean => {
    return playStore.playCount === 0 && sessionStore.currentSessionMode.sessionMode !== SessionMode.PlayingStarted;
  };

  return (
    <PlayListWrapper>
      <SectionHeadline>
        <span>{playStore.playCount} plays</span>
        <AddPlayMenu />
      </SectionHeadline>
      <Paper className='tagging-column'>
        <>
          {playStore.inningManager.inningsReversed.map((inning: IInning, index: number) => {
            return (
              <InningSection
                number={inning.number}
                isTop={inning.isTop}
                plays={playStore.getDisplayPlaysForInning(index)}
                key={index}
                isInitiallyCollapsed={index !== 0}
                onPlaySelected={(play) => (playStore.selectedPlay = play)}
                selectedPlayObjectId={playStore.selectedPlay ? playStore.selectedPlay.id : undefined}
                shouldDisplayPlaceholder={playStore.shouldDisplayPlaceholder}
              />
            );
          })}
          {renderPlaceholder() && <PlayPlaceholder />}
        </>
      </Paper>
    </PlayListWrapper>
  );
});

export default PlayList;
